import React from "react";
import { useLocation } from "react-router-dom";
import ETicketDetailInfo from "../../components/Detail/_ETicketDetailInfo";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

  
function ETicketDetail() {
    let query = useQuery();

    return (
        <div>
            <ETicketDetailInfo ID={query.get("ID")} department={query.get("Dept")}/>
        </div>
    );
}

export default ETicketDetail;